import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss'],
})
export class BurgerMenuComponent implements OnInit {
  public show;
  public mobile = false;

  constructor(private router: Router) {}

  openAndCloseMenu() {
    document.querySelector('#menu').classList.toggle('hidden');
  }

  ngOnInit(): void {
    if (window.screen.width <= 540) {
      // 768px portrait

      this.mobile = true;
    }
  }

  checkIfIhaveToCloseMenu($event) {
    if ($event) {
      this.openAndCloseMenu();
    }
  }

  goToUfaPage() {
    this.router.navigateByUrl('ufa');
  }

  goToApprenticePage() {
    this.router.navigateByUrl('apprenti');
  }

  goToEmployerPage() {
    this.router.navigateByUrl('employeur');
  }

  goToAboutPage() {
    this.router.navigateByUrl('a-propos');
  }

  goToContactPage() {
    this.router.navigateByUrl('contact');
  }

  goToTraining() {
    this.router.navigateByUrl('formations');
  }
}
